/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EMapTypeId {
  HYBRID = 'hybrid',
  ROADMAP = 'roadmap',
  SATURATED = 'saturated'
}
